import React, { useEffect, useState } from "react";
import { format } from "date-fns";
import { toZonedTime } from "date-fns-tz";
import { ptBR } from "date-fns/locale";

import giftIcon from "../../assets/giftIcon.png";
import lock from "../../assets/lock.png";
import {
  Container,
  ContentContainer,
  SweepstakeInfoContainer,
  ProductInfoContainer,
  WinnersContainer,
} from "./styles";
import ToolHelper from "../../utils/ToolHelper";

const ProductCards = ({
  title,
  subtitle,
  disclaimer,
  data = [],
  isWinnerScreen,
  rafflesVersions,
  onChangeTab,
}) => {
  const [deviceWidth, setDeviceWidth] = useState(window.innerWidth);
  const formatedDate = (date) => {
    const timeZone = "America/Sao_Paulo";
    const dataBrasil = toZonedTime(date, timeZone);
    return format(dataBrasil, "dd/MM/yyyy", { locale: ptBR });
 };

  useEffect(() => {
    const handleResize = () => {
      setDeviceWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const renderSweepstakeInfo = (content, index, hasWinner) => {
    return (
      <SweepstakeInfoContainer key={index} hasWinner={hasWinner}>
        <div className="sweepstake-infos">
          <img src={hasWinner ? giftIcon : lock} alt="icon" className="icon" />
          <span className="sweepstake-position-txt">{index + 1}º Sorteio</span>
          <div className="sweepstake-status">
            <span className="sweepstake-status-txt">
              {hasWinner ? "Sorteado" : formatedDate(content?.EndDate__c)}
            </span>
          </div>
        </div>
        {!isWinnerScreen && deviceWidth > 900 && hasWinner && (
          <div className="sweepstake-link">
            <button onClick={() => onChangeTab("Ganhadores")}>
              <span className="link">Confira os ganhadores</span>
            </button>
          </div>
        )}
      </SweepstakeInfoContainer>
    );
  };

  const renderProductInfos = (content, hasWinner) => {
    return (
      <ProductInfoContainer hasWinner={hasWinner}>
        {content?.products?.length > 0 &&
          content?.products?.map((product, index) => (
            <div
              key={index}
              className={`product-infos ${product?.Name?.toLowerCase()}`}
            >
              <img
                src={product?.ImageUrl__c}
                alt="product"
                className={`product-img ${product?.Name?.toLowerCase()}`}
              />

              <div className="product-title">
                <span className="product-title-txt">{product?.Name}</span>

                <span className="product-winners-quantity">
                  0{product?.Quantity__c}{" "}
                  {product?.Quantity__c > 1 ? "contemplados" : "contemplado"}
                </span>

                {product?.Disclaimer__c && (
                  <span className="product-winners-quantity">
                    {product?.Disclaimer__c}
                  </span>
                )}
              </div>
              {!isWinnerScreen && deviceWidth <= 900 && hasWinner && (
                <div className="sweepstake-link">
                  <button onClick={() => onChangeTab("Ganhadores")}>
                    <span className="link">Confira os ganhadores</span>
                  </button>
                </div>
              )}
            </div>
          ))}
      </ProductInfoContainer>
    );
  };

  const renderWinnerInfos = (content, index, hasWinner) => {
    return (
      isWinnerScreen &&
      content?.winners?.length > 0 && (
        <WinnersContainer key={index}>
          <table className="winners-table">
            <thead>
              <tr>
                <th>Número</th>
                <th>Nome</th>
                <th>Prêmio</th>
              </tr>
            </thead>
            <tbody>
              {content?.winners?.map((winner, idx) => (
                <tr key={idx}>
                  <td>{ToolHelper?.maskVoucher(winner?.Number__c)}</td>
                  <td>{winner?.Name}</td>
                  <td>{winner?.ProductName || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </WinnersContainer>
      )
    );
  };

  return (
    <Container dataLength={data?.length || 0}>
      <div className="component-title-container">
        <span className="component-title-txt">{title}</span>
        <span className="component-subtitle-txt">{subtitle}</span>
        <span className="component-disclaimer-txt">{disclaimer}</span>
      </div>

      <div className="data-container">
        {data?.length > 0 &&
          data.map((content, index) => {
            const hasWinner = content?.winners?.length > 0;
            return (
              <ContentContainer
                key={index}
                className="content-container"
                background={content?.backgroundImageUrl__c}
                hasWinner={hasWinner}
              >
                {content?.backgroundImageUrl__c && (
                  <img
                    src={content?.backgroundImageUrl__c}
                    alt="background"
                    className="backgroundImage"
                  />
                )}
                {renderSweepstakeInfo(content, index, hasWinner)}

                <div className="data-infos-container">
                  {renderProductInfos(content, hasWinner)}
                  {renderWinnerInfos(content, index, hasWinner)}
                </div>
              </ContentContainer>
            );
          })}
      </div>
    </Container>
  );
};
export default ProductCards;
